import CircularProgress from "@mui/material/CircularProgress";

export const LoadingScreen = () => {
  return (
      <div id="loading-screen">
        <CircularProgress />
      </div>
  );
};
